import React from 'react';
import { CollectionType, ICollection } from 'types';
import BannerCollection from './BannerCollection';
import SingleBannerCollection from './SingleBannerCollection';
import GridCollection from './GridCollection';
import CardCollection from './CardCollection';
import DefaultCollection from './DefaultCollection';

interface Props {
  collection: ICollection;
}

function Preview({ collection }: Props) {
  const { type } = collection;
  if (type === CollectionType.MAIN_BANNER)
    return <BannerCollection collection={collection} />;

  if (type === CollectionType.SINGLE_BANNER)
    return <SingleBannerCollection collection={collection} />;

  if (type === CollectionType.GRID)
    return <GridCollection collection={collection} />;

  if (type === CollectionType.CARD)
    return <CardCollection collection={collection} />;

  return <DefaultCollection collection={collection} />;
}

export default Preview;
